import React from "react";
import "./Tabs.css";

function Tabs({ tabs, value, onChange, ariaLabel, className = "" }) {
    return (
        <div
            className={`tabs ${className}`}
            role="tablist"
            aria-label={ariaLabel}
        >
            {tabs.map((tab) => {
                const active = tab.value === value;
                const Icon = tab.icon;
                return (
                    <button
                        key={tab.value}
                        type="button"
                        role="tab"
                        aria-selected={active}
                        className={`tabs__tab focus-ring ${active ? "is-active" : ""}`}
                        onClick={() => onChange?.(tab.value)}
                    >
                        {Icon && <Icon size={14} aria-hidden="true" />}
                        <span>{tab.label}</span>
                        {tab.count != null && (
                            <span className="tabs__count mono-num">{tab.count}</span>
                        )}
                    </button>
                );
            })}
        </div>
    );
}

export default Tabs;
